import * as React from "react";

import { useStaticQuery, graphql } from "gatsby";
import PropTypes from "prop-types";
import { createStore } from "redux";
import { Provider } from "react-redux";
import Header from "@envy/Header";
import LetsTalk from "@envy/LetsTalk";
import AlertBar from "@components/AlertBar";
import ContactForm from "@envy/ContactForm";
import favicon from "@images/envy/favicon.png";

const { optionTypes } = ContactForm;
const initialState = {
  contactFormOption: optionTypes.TALK,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_CONTACT_TALK":
      return {
        ...state,
        contactFormOption: optionTypes.TALK,
      };
    case "SET_CONTACT_TOUR":
      return {
        ...state,
        contactFormOption: optionTypes.TOUR,
      };
    case "SET_CONTACT_COWORKING":
      return {
        ...state,
        contactFormOption: optionTypes.COWORKING,
      };
    default:
      return state;
  }
};

const Layout = ({ transparentHeader, children, availability }) => {
  const store = createStore(reducer);
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <Provider store={store}>
      <AlertBar propertySlug="envy" />
      <Header
        siteTitle={data.site.siteMetadata?.title || "Envy"}
        icon={favicon}
        transparent={transparentHeader}
        availability={availability || false}
      />

      <main style={{ overflowX: "hidden" }}>
        <div style={{ position: "relative" }}>
          {children}
          <LetsTalk />
        </div>
      </main>
    </Provider>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  transparentHeader: PropTypes.bool,
  availability: PropTypes.bool,
};

Layout.defaultProps = {
  transparentHeader: true,
};

export default Layout;
